import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import './LoginPage.scss';
import axios from "axios";

function LoginPage() {
  const [loginError, setLoginError] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    let ls = localStorage.getItem("stadata-token");
    if (ls) {
      setTimeout(() => {
        navigate("/");
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoginError('');
      setSpinner(true);
      const payload = {
        email: formData.email,
        password: formData.password,
      };
      let headers = {
        "Content-Type": "application/json",
      };
      const apiUrl = `${process.env.REACT_APP_API_URL}/auth/stadata`;
      const response = await axios.post(apiUrl, payload, { headers: headers });
      if (response?.data?.token) {
        localStorage.setItem("stadata-token", response?.data?.token);
        localStorage.setItem("stadata-auth", JSON.stringify(response?.data));
        localStorage.setItem("stadata-guest-session", false);
        navigate("/");
      }
      setSpinner(false);
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        setLoginError('Invalid email or password');
      }
      setSpinner(false);
      console.error("Error:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-10 pb-12 rounded-lg shadow-lg border border-gray-300">
        <div className="flex items-center justify-center">
          <img src="stadata-logo.png" className="mb-2 center" width="25px" alt="logoalt"></img>
        </div>
        <h2 className="text-2xl text-gray-600 mb-5 text-center">Sign in with your Stadata account</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Enter your email"
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Enter your password"
            />
          </div>
          <div className="flex items-center justify-between">
            <button type="submit"
              disabled={spinner}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
            >
              { spinner ? 'Submitting...' : 'Sign In' }
            </button>
          </div>
        </form>
        { spinner && (
          <div className="flex justify-center mt-3 absolute left-1/2 transform -translate-x-1/2">
            <div className="w-6 h-6 border-4 border-t-4 border-t-blue-500 border-gray-200 rounded-full animate-spin"></div>
          </div>
        )}
        { loginError && (
          <div className="text-red-500 text-center flex justify-center mt-2 absolute left-1/2 transform -translate-x-1/2">
            { loginError }
          </div>
        )}
        <div class="text-center mt-2">
          <p class="mt-2 text-black">OR</p>
          <a href="/" class="underline" style={{color: "blue"}}>Continue as Guest</a>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;